import { useNavigation } from '@/shared/hooks';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';
import { Button } from '@noorden-insurtech/alba-design-system';
import { ArrowLeft, Home } from 'lucide-react';
import { IntegrationDetailsPage } from '../../../../features/integrations/components/integration-details-page.component';
import { Page, PageHeader } from '../../../../shared/ui/page';

export const Route = createFileRoute('/_app/integrations/$policyId/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions([
      'policies.integrations.read',
    ]);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  const { policyId } = useParams({ strict: false });
  const { push } = useNavigation();
  const safePolicyId = policyId ?? '';
  const truncateMiddle = (value: string, start = 14, end = 10) => {
    if (!value) return '-';
    if (value.length <= start + end + 3) return value;
    return `${value.slice(0, start)}...${value.slice(-end)}`;
  };
  const mobilePolicyLabel = truncateMiddle(safePolicyId);

  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Página Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Integrações', href: '/integrations' },
          { label: `Apólice ${mobilePolicyLabel}`, active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <Button
            variant='ghost'
            size='sm'
            className='self-start px-2 sm:px-0'
            onClick={() => push('/integrations')}
          >
            <ArrowLeft className='w-4 h-4 mr-1' />
            Voltar
          </Button>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Detalhes da Integração</PageHeader.Title>
            <PageHeader.Subtitle>
              <span className='sm:hidden'>Apólice {mobilePolicyLabel}</span>
              <span className='hidden sm:inline'>Apólice {safePolicyId}</span>
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <IntegrationDetailsPage policyId={safePolicyId} />
    </Page.Root>
  );
}
